import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { processAnswers } from "../../libs/processAnswers";
import { processQuestions } from "../../libs/processQuestions";
import {
  Row,
  Col,
  Panel,
  Badge,
  Image,
  Collapse,
  FormGroup,
  FormControl,
} from "react-bootstrap";
import { 
  ChevronDown
} from 'react-feather';
import { Helmet } from 'react-helmet';
import Loader from "../../components/Loader";
import LoaderButton from "../../components/LoaderButton";
import defaultAvatar from "../../assets/avatar.png"
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import Answer from "../../components/Answer"
import RHS from "../../components/RHS";
import "./Question.css";

export default function Question(props) {
  const [question, setQuestion] = useState(null);
  const [answers, setAnswers] = useState(null);
  const [isInteracting, setIsInteracting] = useState(false);
  const [answer, setAnswer] = useState("");
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [isAnswering, setIsAnswering] = useState(false);
  const [isAnswerPanelOpen, setIsAnswerPanelOpen] = useState(false);
  const [answered, setAnswered] = useState(false);
  const [credential, setCredential] = useState("");
  const onChangeEditor = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    setAnswer(JSON.stringify(rawContentState));
    setEditorState(editorState);
  };

  useEffect(() => {
    // get question
    let path = "questions/" + props.match.params.question_id;
    API.get('questions', path).then(async resp => {
      // comm data
      props.setIsMember(false);
      [...props.communities, ...props.myCommunities].forEach(comm => {
        if (comm.keyword === resp.keyword){
          if (props.user.communities && props.user.communities.includes(comm.comm_id))
            props.setIsMember(true);
          props.setCommunity(comm);
        }
      });
      const processedQuestion = await processQuestions([resp]);
      setQuestion(processedQuestion[0]);
    });

    let interactions;
    // attempt to get user response and comment interactions if logged in
    if (Object.keys(props.user).length !== 0) {
      path = 'answer_interactions/' + props.match.params.question_id;
      const params = {queryStringParameters: {UID: props.user.UID}};
      interactions = API.get('questions', path, params);
    } 

    // get (and process) answers
    path = 'answers/' + props.match.params.question_id;
    API.get('questions', path).then(async resp => {
      interactions = await interactions;
      interactions = interactions ? interactions.interactions : {};
      let answers = await processAnswers(resp, interactions, props.user.UID);
      answers = answers.filter(cmnt => !cmnt.deleted);
      answers.sort(function (a, b) {return parseInt(b.ups) - parseInt(a.ups);});
      if (answers.some(e => e.author_id === props.user.UID)) setAnswered(true)
      setAnswers(answers);
    });

    if (props.user.credential) {
      setCredential(props.user.credential);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function createAnswer(answer) {
    if (!props.isAuthenticated) 
      props.history.push("/login?redirect=/questions/" + props.match.params.question_id);
    if (isAnswering) return;
    if (!answer) return;
    setAnswer("");

    if(credential !== props.user.credential) {
      API.post('users', 'update_user', {
        body: {
          UID: props.user.UID,
          credential: credential
        }
      });
    }

    const data = {body: {
      question_id: props.match.params.question_id,
      text: answer,
      UID: props.user.UID
    }};
    setIsAnswering(true);
    API.post('questions', 'create_answer', data).then(resp => {
      let cmnt_new = {
        answer_id: resp,
        ups: 0,
        downs: 0,
        text: answer,
        award: 0,
        author: {
          UID: props.user.UID, 
          fullname: props.user.fullname, 
          avatarURL: props.avatar
        },
        time: "Just now",
        upVoted: false,
        downVoted: false,
        awarded: true,
        canDelete: true
      }
      if (Boolean(credential)) {
        cmnt_new.author.credential = credential;
      }
      setAnswers([cmnt_new, ...answers]);
      setQuestion(Object.assign({}, question, {answers: question.answers + 1}));
      setAnswered(true);
      setIsAnswering(false);
      setIsAnswerPanelOpen(false);
    });
  }

  // TODO: right now this creates a new record instead of modifying the existing record, could change
  function editAnswer(cmnts, idx, answer) {
    if (!props.isAuthenticated) 
      props.history.push("/login?redirect=/questions/" + props.match.params.question_id);
    if (isAnswering) return;

    let cmnt_id = cmnts[idx].answer_id;
    let numRm = 1;
    const data = {body: {
      question_id: props.match.params.question_id,
      answer_id: cmnt_id,
      num_rm: numRm,
      UID: props.user.UID
    }};
    setIsAnswering(true);
    API.post('questions', 'delete_answer', data).then(resp => {
      cmnts.splice(idx, 1);
      setAnswers(cmnts);
      setQuestion(Object.assign({}, question, {answers: question.answers - numRm})); 
      setIsAnswering(false); 
      setAnswered(false);
      setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(answer.text))));
      setAnswer(answer.text);
      setIsAnswerPanelOpen(true)  
    });
  }

  function interact(answers, type, idx) {
    if (isInteracting) return;
    if (!props.isAuthenticated) 
      props.history.push("/login?redirect=/questions/" + props.match.params.question_id);
    let answer = answers[idx];
    if (type === 'up') {
      if (!answer.upVoted) {
        if (answer.downVoted) {
          answer.downs -= 1;
          answer.downVoted = false;
        }
        answer.ups += 1
        answer.upVoted = true
      } else {
        return;
      }
    } else {
      if (props.user.icoins < 1) {
        alert("Not enough icoin! Earn more icoin before giving awards.");
        return;
      }
      if (!answer.awarded) {
        answer.award += 1
        answer.awarded = true

        const icoin = props.user.icoins - 1;
        props.setUser(Object.assign({}, props.user, {icoins: icoin}));
      } else {
        return;
      }
    }
    answers[idx] = answer
    setAnswers(answers);
    setIsInteracting(true);
    const data = {body: {
      question_id: props.match.params.question_id,
      answer_id: answer.answer_id,
      action: type,
      UID: props.user.UID
    }};
    if (type === 'award')
      data.body.author_id = answer.author.UID;
    API.post('questions', 'interact_answer', data).then(resp => setIsInteracting(false));
  }

  const footer = answered ? null : (
    <div>
      <span 
        style={{paddingTop: "10px", cursor: "pointer"}} 
        className="text-muted"
        onClick={() => setIsAnswerPanelOpen(!isAnswerPanelOpen)} 
      >
        <span style={{verticalAlign: "7px"}}>
          Answer
        </span>
        <ChevronDown />
      </span>
      <Collapse in={isAnswerPanelOpen}>
        {/* double wrapped for smooth animations */}
        <div>
          <div style={{marginTop:"10px", marginBottom: "50px"}}>
            <div style={{display: 'flex', marginBottom: '10px', border: '1px solid black', backgroundColor: "#f0f0f0", borderRadius: '5px', padding: '15px'}}>
              <div
                style={{backgroundImage: `url(${props.avatar}), url(${defaultAvatar})`}}
                className="article-avatar"
                />
                <div style={{marginLeft: '5px', textAlign: 'left'}}>
                  <span style={{color: 'black'}}>
                    {props.user.fullname}
                  </span>
                  <br/>
                  <FormGroup style={{marginBottom: '0px'}}>
                    <FormControl
                      value={credential}
                      placeholder="Edit Credential"
                      maxLength={40}
                      onChange={e => setCredential(e.target.value)}
                    />
                  </FormGroup>
                </div>
            </div>
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClass"
              wrapperClassName="wrapperClass"
              editorClassName="editorClass"
              onEditorStateChange={onChangeEditor}
              stripPastedStyles={true}
              toolbar={{
                options: ['inline', 'list', 'link', 'emoji', 'image'],
                inline: {
                  options: ['bold', 'italic', 'underline', 'strikethrough'],
                },
                list: {
                  options: ['unordered', 'ordered'],
                },              
                link: {
                  options: ['link'],
                },              
                image: {
                  defaultSize: {
                    height: 'auto',
                    width: '100%',
                  }                
                }
              }}
            />
            <h5 className="warning-text" style={{marginBottom: "0px", marginTop: "4px"}}>
              icitizen is strictly nonpartisan and everyone is welcome to join. 
              As a reminder, please keep your posts civil and courteous to others.
              Don't attack people. Personal insults, hate speech, profanity, any advocating or wishing death/physical harm, 
              and other violations of civil discourse can result in a permanent ban at the sole discretion of icitizen. 
              If you see posts in violation of our standards of conduct, please report them 
              to <a href="mailto:team@icitizen.com?subject=Report User Poll">team@icitizen.com</a>.
            </h5>
            <LoaderButton
              style={{marginBottom: "5px", "float": "right"}}
              onClick={()=>createAnswer(answer)}
              isLoading={isAnswering}
            >
              Submit
            </LoaderButton>
          </div>
        </div>
      </Collapse>
    </div>
  );
  
  // probably a smarter way to do this but i forgot and who cares ill just refactor later
  function renderStats(answers) {
    if (answers === 0) {
      return (
        <div>
          <span> Be the first to answer </span>
        </div>
      )
    }
    else if (answers === 1) {
      return (
        <div>
          <span> {answers} answer </span>
        </div>
      )
    }
    else {
      return (
        <div>
          <span> {answers} answers </span>
        </div>
      )
    }
  }

  const questionRender = question ? (
    <Panel className="poll-answer-panel">
      <Panel.Heading className="poll-answer-panel-heading">
      <div style={{paddingBottom: "10px"}}>
        <div
          style={{backgroundImage: `url(${question.author.avatarURL}), url(${defaultAvatar})`}}
          className="article-avatar"
        />
        <div className="profile-text-card" style={{marginTop: "3px"}}>
          <span className="author-name">
          { question.author.fullname }<br/>
          </span>
          <span className="text-muted">
            Asked { 
              new Intl.DateTimeFormat('en-US', { 
                month: 'short',
                day: 'numeric',
                year: 'numeric' 
              }).format(new Date(question.date_created))
            }
          </span>
        </div>
        <span style={{display: "grid", paddingTop: "5px"}} className="pull-right">
          <Badge 
            className="poll-tag" 
            style={{color: '#fff', background: '#777', cursor: 'pointer'}} 
            onClick={() => {props.history.push("/communities/" + props.community.comm_id)}}
          >
            { question.keyword }
          </Badge>
          <span className="text-muted poll-stats">
            {renderStats(question.answers)}
          </span>
        </span>
      </div>
      <h2 className="poll-card-title">
        { question.question }
      </h2>
      </Panel.Heading>
      <Panel.Body style={{marginTop: "-10px", marginBottom: "-30px"}}>
        { question.img && (
            <Row>
              <Col xs={12}>
                <Image src={question.img} className="vid" style={{width: '100%'}} rounded />
              </Col>
            </Row>
          ) 
        }
      </Panel.Body>
      <Panel.Footer className="poll-answer-panel-heading" style={{textAlign: "center"}}>
        { footer }
      </Panel.Footer>
    </Panel>
  ) : null;


  function getTruncatedAnswer(answers) {
    if (answers[0]) {
      const text = convertFromRaw(JSON.parse(answers[0].text)).getPlainText();
      const truncatedText = text.length > 55 ? `${text.substring(0, 55)}...` : text;
      return truncatedText
    }
    // is this even necessary
    else return null
  }

  return question ? (
    <div>
      <Helmet>
        <title>{question.question} | icitizen</title>
        <meta name="title" content={`${question.question}`}/>
        <meta name="description" content={answers ? getTruncatedAnswer(answers) : question.question}/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={window.location.href}/>
        <meta property="og:title" content={`${question.question} | icitizen`}/>
        <meta property="og:description" content={answers ? getTruncatedAnswer(answers) : question.question}/>
        <meta property="og:image" content={question.img ? question.img : "https://icitizen.com/ic_card.png"}/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content={window.location.href}/>
        <meta property="twitter:title" content={`${question.question} | icitizen`}/>
        <meta property="twitter:description" content={answers ? getTruncatedAnswer(answers) : question.question}/>
        <meta property="twitter:image" content={question.img ? question.img : "https://icitizen.com/ic_card.png"}/> 
      </Helmet>
      { 
        props.width === 'xl' ? (
          <Row>
            <Col xs={8}>
              { questionRender }
              { answers ? 
                [...answers].map((answer, idx) => (
                  <Answer key={answer.answer_id} idx={idx} answer={answer} answers={answers} deleteAnswer={editAnswer} interact={interact} truncated={false} />
                ))
                : null
              }
            </Col>
            <Col xs={4}>
              <Row>
                  { RHS(props) }
              </Row>
            </Col>
          </Row>
        ) : (
          <Row className="content-spaced">
            <Col xs={12}>
              { questionRender }
              { answers ? 
                [...answers].map((answer, idx) => (
                  <Answer key={answer.answer_id} idx={idx} answer={answer} answers={answers} deleteAnswer={editAnswer} interact={interact}/>
                ))
               :
               null
            }
            </Col>
          </Row>
        )
      }
    </div>
  ) : (<Loader />);
}
